import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enviroment } from '../../environments/environment';
import { PostReqTotalBankAgreement } from '../models/request/post-req-total-bank-agreement';
import { PostResTotalBankAgreement } from '../models/response/post-res-total-bank-agreement';
import { PutReqTotalBankAgreement } from '../models/request/put-req-total-bank-agreement';
import { PutResTotalBankAgreement } from '../models/response/put-res-total-bank-agreement';
import { GetResOpenfinanceUrl } from '../models/response/get-res-openfinance-url.model';
import { PostReqOpenfinanceAgreement } from '../models/request/post-req-openfinance-agreement';
import { PutReqOpenfinanceAgreement } from '../models/request/put-req-openfinance-agreement';
import { PutResOpenfinanceAgreement } from '../models/response/put-res-openfinance-agreement';
import { GetResApiAgreements } from '../models/response/get-res-api-agreements.model';
import { GetResApiAgreementsStatusCount } from '../models/response/get-res-api-agreements-status-count.model';

@Injectable({
  providedIn: 'root'
})
export class IntegrationService {
  apiUrl: string;

  constructor(private http: HttpClient) { 
    this.apiUrl = `${enviroment.API_URL}/conta-acesso/{access-account}/agrupador/{group}/integracao`;
  }

  postTotalBankAgreement(body: PostReqTotalBankAgreement): Observable<PostResTotalBankAgreement> {
    const accessAccount = localStorage.getItem('accessAccount') || '';
    const group = localStorage.getItem('groupId') || '';
    let url = `${this.apiUrl.replace('{access-account}', accessAccount).replace('{group}', group)}/totalbank/consentimento`;
    return this.http.post<PostResTotalBankAgreement>(url, body);
  }

  putTotalBankAgreement(body: PutReqTotalBankAgreement): Observable<PutResTotalBankAgreement>{
    const accessAccount = localStorage.getItem('accessAccount') || '';
    const group = localStorage.getItem('groupId') || '';
    let url = `${this.apiUrl.replace('{access-account}', accessAccount).replace('{group}', group)}/totalbank/consentimento`;
    return this.http.put<PutResTotalBankAgreement>(url, body);
  }  

  getImportProgress(idSub: string): Observable<any> {
    const url = `${enviroment.API_URL}/integracao/import-progress/user/${idSub}`;
    return this.http.get<any>(url).pipe();
  }
  
  postOpenfinanceAgreement(body: PostReqOpenfinanceAgreement): Observable<GetResOpenfinanceUrl> {
    const accessAccount = localStorage.getItem('accessAccount') || '';
    const group = localStorage.getItem('groupId') || '';
    let url = `${this.apiUrl.replace('{access-account}', accessAccount).replace('{group}', group)}/openfinance/consentimento`;
    return this.http.post<GetResOpenfinanceUrl>(url, body).pipe();
  }

  putOpenfinanceAgreement(body: PutReqOpenfinanceAgreement): Observable<PutResOpenfinanceAgreement> {
    const accessAccount = localStorage.getItem('accessAccount') || '';
    const group = localStorage.getItem('groupId') || '';
    let url = `${this.apiUrl.replace('{access-account}', accessAccount).replace('{group}', group)}/openfinance/consentimento`;
    return this.http.put<PutResOpenfinanceAgreement>(url, body).pipe();
  }

  getApiAgreements(): Observable<GetResApiAgreements> {
    const accessAccount = localStorage.getItem('accessAccount') || '';
    const group = localStorage.getItem('groupId') || '';
    let url = `${this.apiUrl.replace('{access-account}', accessAccount).replace('{group}', group)}`;
    return this.http.get<GetResApiAgreements>(url).pipe();
  }

  getApiAgreementsStatusCount(): Observable<GetResApiAgreementsStatusCount> {
    const accessAccount = localStorage.getItem('accessAccount') || '';
    const group = localStorage.getItem('groupId') || '';
    let url = `${this.apiUrl.replace('{access-account}', accessAccount).replace('{group}', group)}/status`;
    return this.http.get<GetResApiAgreementsStatusCount>(url).pipe();
  }  
}
